import { useContext } from "react";
import { Thead, THT, THTS } from "../../components";
import TableContext from "../Provider/TableContext";

function TableHead() {
  const { setOrder = () => {} } = useContext(TableContext);

  return (
    <Thead>
      <THTS txt="Expense Name" field="name" setOrder={setOrder} />
      <THTS txt="Description" field="description" setOrder={setOrder} />
      <THTS txt="Status" field="expense_status" setOrder={setOrder} />
      <THTS txt="Amount" field="amount" setOrder={setOrder} />
      {/* <THTS txt="Approved By" field="approved_by" setOrder={setOrder} /> */}
      <THT txt="Actions" />
    </Thead>
  );
}

export default TableHead;
